export type LoginMethodKind = 'password' | 'totp' | 'recovery_code' | 'google';
export interface LoginMethod { id: string; kind: LoginMethodKind; revoked?: boolean }
export interface ImpersonationState { impersonationId?: string; impersonationExpiresAt?: string; impersonationReason?: string }

const PRIMARY_LOGIN_METHODS = new Set<LoginMethodKind>(['password', 'google']);

export function canRemoveLoginMethod(methods: readonly LoginMethod[], methodId: string): boolean {
  const activePrimary = methods.filter((method) => !method.revoked && PRIMARY_LOGIN_METHODS.has(method.kind));
  const target = activePrimary.find((method) => method.id === methodId);
  return !target || activePrimary.length > 1;
}

export function mutationBlockReason(principal: ImpersonationState | undefined, mutation: 'credential' | 'identity_link' | 'global_admin' | 'realm_admin' | 'ordinary'): string | undefined {
  if (principal?.impersonationId && mutation !== 'ordinary') {
    return 'Non podes cambiar credenciais nin ligazóns mentres estás suplantando unha identidade.';
  }
  return undefined;
}

export function isImpersonating(principal: ImpersonationState | undefined): boolean {
  return Boolean(principal?.impersonationId);
}
